import * as R from 'remeda'

import { type FiveSegmentCounts, toFiveSegmentCounts } from '~/utils'

import { type NineSegmentsCustomerAttributeData } from './buildNineSegmentsCustomerAttributesArrayData'
import { type FiveSegmentsData } from './fiveSegments'

export type FiveSegmentsCustomerAttributeData = FiveSegmentsData & {
  customerAttribute: { id: string; name: string }
  customerAttributeGroup: { name: string }
  number: number
}

export type FiveSegmentsCustomerAttributesArrayDataInput = {
  // Curried per-row builder from useGetFiveSegmentsData.
  getFiveSegmentsData: (
    fiveSegmentCounts: FiveSegmentCounts,
    total: number,
  ) => FiveSegmentsData
  nineSegmentsCustomerAttributesArrayData: ReadonlyArray<
    ReadonlyArray<NineSegmentsCustomerAttributeData>
  >
  // Sort function from useAtomValue(fiveSegmentSortFunctionAtom); basic-output supplies
  // identity for offline render.
  sort: (
    rows: FiveSegmentsCustomerAttributeData[],
  ) => FiveSegmentsCustomerAttributeData[]
}

export const buildFiveSegmentsCustomerAttributesArrayData = (
  input: FiveSegmentsCustomerAttributesArrayDataInput,
): FiveSegmentsCustomerAttributeData[][] =>
  R.pipe(
    input.nineSegmentsCustomerAttributesArrayData,
    R.map((nineSegmentsCustomerAttributesData) =>
      R.pipe(
        nineSegmentsCustomerAttributesData,
        R.map((nineSegmentsCustomerAttributeData) => {
          const fiveSegmentCounts = toFiveSegmentCounts(
            nineSegmentsCustomerAttributeData.counts,
          )
          const total = nineSegmentsCustomerAttributeData.counts.total

          return {
            ...nineSegmentsCustomerAttributeData,
            ...input.getFiveSegmentsData(fiveSegmentCounts, total),
          }
        }),
        input.sort,
      ),
    ),
  )
